import * as t from 'io-ts';

export const decoder = t.type({
  message: t.union([t.string, t.undefined]),
  errors: t.union([
    t.array(t.type({
      field: t.string,
      type: t.string,
      parameters: t.union([
        t.array(
          t.union([t.string, t.number]),
        ),
        t.undefined,
      ]),
    })),
    t.undefined,
  ]),
});
